'use client';

import { useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../../contexts/ApiContext';
import { queryKeys } from '../../../../lib/queryClient';
import {
  SetRushMidWeaponSkinRequestWeaponKeyEnum,
  type RushMidSkinsResponse,
} from '../../../../services/generated/Api';

export function useWeaponSkinPersist(): (
  weaponKey: SetRushMidWeaponSkinRequestWeaponKeyEnum,
  skin: string | null,
) => Promise<void> {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return async (weaponKey, skin) => {
    await apiClient.api.rushMidControllerSetWeaponSkin({ weaponKey, skin });
    queryClient.setQueryData<RushMidSkinsResponse>(queryKeys.rushMidSkins, (old) => {
      if (!old) return old;
      const weapons = { ...old.weapons };
      if (skin) weapons[weaponKey] = skin;
      else delete weapons[weaponKey];
      return { ...old, weapons };
    });
  };
}
